import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CCol,
  CButton,
  CCardFooter,
  CNav,
  CNavItem,
  CNavLink
} from "@coreui/react";
import { connect } from "react-redux";
import { InputGroup, Input, InputGroupAddon, InputGroupText } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import EditNewton from "../../../components/EditNewton";
import Interface from "../../../components/Interface";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import "./style.css";

class Newton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      search: "",
      tab: 0,
      iframe: false,
      content: null,
      selected: null,
      objective: null
    };
  }

  componentDidMount() {
    this.initContent();
  }

  initContent() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    axios
      .get(`${URL.api}classification/objective/singleViewByCode/Newton`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(respObjective => {
        const filters = {
          type: 6,
          segment: null,
          discipline: null,
          serie: null,
          ability: null,
          content: true,
          status: "%"
        };

        axios
          .post(`${URL.api}content/los/listLosFilter`, filters, {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            this.setState({
              content: resp.data.data,
              objective: respObjective.data.data,
              loading: false
            });
          });
      });
  }

  filter(shouldLoad = true) {
    if (shouldLoad) {
      this.setState({ loading: true });
    }

    const filters = {
      type: 6,
      word: this.state.search,
      segment: null,
      discipline: null,
      serie: null,
      ability: this.state.tab || null,
      content: true,
      status: "%"
    };

    axios
      .post(`${URL.api}content/los/listLosFilter`, filters, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ content: resp.data.data, loading: false });
      });
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          {this.state.edit && (
            <EditNewton
              show
              newton={this.state.selected}
              onClose={() =>
                this.setState({ edit: false }, () => this.filter(false))
              }
            />
          )}
          {this.state.iframe && (
            <Interface
              show={this.state.iframe}
              title={this.state.selected?.name}
              onClose={() => this.setState({ iframe: false })}
              aula={this.state.selected?.id}
              currentRoute={this.props.currentRoute}
            />
          )}
          <CCardHeader
            className="d-flex flex-column justify-content-center pb-0"
            style={{ borderBottom: 0 }}
          >
            <div className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div className="d-flex align-items-center mb-1">
                  <h4 className="card-title m-0 border-0 mr-1">Newton</h4>
                </div>
                <div className="small text-muted">
                  Faça ajustes nos simuladores do Newton
                </div>
              </div>
              <div
                className="float-right d-none d-md-block"
                style={{ width: "30%" }}
              >
                <InputGroup>
                  <Input
                    placeholder="Pesquisar"
                    onChange={e => this.setState({ search: e.target.value })}
                    value={this.state.search}
                    type="text"
                    style={{
                      borderRight: 0,
                      outline: 0,
                      borderColor: "#d8dbe0",
                      boxShadow: "none"
                    }}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText className="bg-white pl-0">
                      <i
                        className="fa fa-search text-muted content-search-icon"
                        onClick={() => this.filter()}
                      ></i>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </div>
            </div>
          </CCardHeader>
          <CNav
            variant="tabs"
            className="nav-underline nav-underline-primary px-1"
            style={{
              marginBottom: "1px",
              borderWidth: "1px",
              borderColor: "#d8dbe0",
              fontWeight: "600"
            }}
          >
            <CNavItem>
              <CNavLink
                className="p-3"
                active={this.state.tab === 0}
                onClick={() => this.setState({ tab: 0 }, () => this.filter())}
              >
                Todos
              </CNavLink>
            </CNavItem>
            {this.state.objective?.abilities.map(ability => (
              <CNavItem key={ability.id}>
                <CNavLink
                  className="p-3"
                  active={this.state.tab === ability.id}
                  onClick={() =>
                    this.setState({ tab: ability.id }, () => this.filter())
                  }
                >
                  {ability.description}
                </CNavLink>
              </CNavItem>
            ))}
          </CNav>
          <CCardBody>
            {this.state.loading ? (
              <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                <Loading />
              </div>
            ) : this.state.content.length === 0 ? (
              <div className="p-4 w-100 d-flex align-items-center justify-content-center text-muted">
                Nenhum simulador publicado
              </div>
            ) : (
              <div
                className="row"
                style={{ marginBottom: "-1.5rem", width: "100%" }}
              >
                {this.state.content[0].content.map(newton => (
                  <CCol key={newton.id} xs="4" lg="3">
                    <CCard
                      className="cursor link"
                      onClick={() =>
                        this.setState({ selected: newton, iframe: true })
                      }
                    >
                      <div className="newton-img-container">
                        <img
                          src={
                            URL.img +
                            (newton.image || "uploads/lo/noPicture.jpg")
                          }
                          alt="Simulador"
                        />
                      </div>
                      <CCardFooter className="flex-column">
                        <div className="w-100 mb-2">
                          <div className="font-weight-bold name">
                            {newton.name}
                          </div>
                          <div className="text-muted small text-ellipsis">
                            {newton.resume || "Sem descrição"}
                          </div>
                        </div>
                        <div className="w-100 d-flex justify-content-between align-items-center text-ellipsis">
                          <div className="d-flex align-items-center small text-muted text-ellipsis">
                            {newton.module_description} -&nbsp;
                            <span className="text-primary">
                              {newton.status}
                            </span>
                          </div>
                          <CButton
                            size="sm"
                            color="primary"
                            className="ml-2"
                            onClick={e => {
                              this.setState({ edit: true, selected: newton });
                              e.stopPropagation();
                            }}
                          >
                            Editar
                          </CButton>
                        </div>
                      </CCardFooter>
                    </CCard>
                  </CCol>
                ))}
              </div>
            )}
          </CCardBody>
        </CCard>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Newton);
